// @flow
import * as React from "react";
// import styled from 'styled-components';

import Container from "./Container";

type Props = {}

class UnableToDetermineDetails extends React.Component<Props> {
	render() {
		return (
			<Container />
		);
	}
}

export default UnableToDetermineDetails;